/**
 *	Clamped
 *	A component for expanding/collapsing truncated intro text.
 *	Delegated from document so it also covers .clamped elements rendered after page load (e.g. via AJAX).
 */
jQuery(function($){
	const shownClass = 'show';
	const clampedSelector = '.clamped';


	/**
	 *	Initialize
	 */
	(function init(){
		$(document).on('click', '[class*="__intro-toggle--more"], [class*="__block-body-toggle--more"]', handleShowMore);
		$(document).on('click', '[class*="__intro-toggle--less"], [class*="__block-body-toggle--less"]', handleShowLess);
	})();

	/**
	 * Show expanded intro
	 * @param {*} event
	 */
	function handleShowMore(event) {
		event.preventDefault();
		$(event.currentTarget).closest(clampedSelector).addClass(shownClass);
	}


	/**
	 * Show collapsed or truncated intro
	 * @param {*} event
	 */
	function handleShowLess(event) {
		event.preventDefault();
		$(event.currentTarget).closest(clampedSelector).removeClass(shownClass);
	}

});
